import { ROLES, USER_ROLES } from '~/utils/constants';

const USER_ROLE_LABELS = {
  [ROLES.ORGANIZATION_ADMIN]: 'Admin (Full access)',
  [ROLES.ORGANIZATION_USER]: 'User (Full access; view-only for wallet & plans)',
};

export const USER_ROLE_OPTIONS = USER_ROLES.map((role) => ({
  ...role,
  title: USER_ROLE_LABELS[role.value] || role.title,
}));
